type AccountlessAppEntryRootState = {
	entities?: {
		accountlessAppEntry?: {
			isEnabled?: boolean;
		};
	};
};

export const selectIsAccountlessAppEntryEnabled = (
	state: AccountlessAppEntryRootState
): boolean => state?.entities?.accountlessAppEntry?.isEnabled === true;
